﻿<template>
    <masked-input-bs 
                     :name="name" 
                     :value="value" 
                     :required="required" 
                     :label-cols="labelCols" 
                     :validation-rules="{ regex: /^\(([0-9]{3})\)([ ])([0-9]{3})-([0-9]{4})$/}" 
                     :mask="['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                     :display-success-validation="displaySuccessValidation"
                     v-on:input="updateValue($event)"></masked-input-bs>    
</template>

<script>
    var maskedInputBs = require('./maskedInputBs.vue');
    module.exports = {        
        components: {
            maskedInputBs: maskedInputBs
        },
        props: {
            name: {
                type: String,
                required: true
            },
            value: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },            
            labelCols: {
                type: Number,
                default: 4
            },
            displaySuccessValidation: {
                type: Boolean,
                default: false
            }
        },
        computed: {            
            styleLabel: function () {
                if (this.labelCols > 0) {
                    return 'col-sm-' + this.labelCols + ' control-label';
                }
                return 'control-label';
            },
            styleInput: function () {
                if (this.labelCols > 0) {
                    return 'col-sm-' + (12 - this.labelCols);
                }
                return '';
            }
        },
        methods: {
            updateValue: function (value) {
                //console.log("input event:" + value);
                var formattedValue = value;
                this.$emit('input', formattedValue);
            }
        }
    }
</script>